var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subitem" }, [
    _c("a", { staticClass: "item-url", attrs: { href: _vm.subitem.url } }, [
      _c("div", { staticClass: "item-wrapper" }, [
        _vm.subitem.image
          ? _c("div", {
              staticClass: "img-wrapper lazyload",
              attrs: { "data-bgset": _vm.subitem.image, "data-sizes": "auto" }
            })
          : _c("div", { staticClass: "img-wrapper empty" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.subitem.title))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }